import { useFormik } from "formik";
import { InputTextarea } from "primereact/inputtextarea";
import { useMutation } from "react-relay";
import { moduleRating_createModuleRatingSubmissionMutation } from "@generated/moduleRating_createModuleRatingSubmissionMutation.graphql";
import { StyledDialog } from "./module-rating-comment-dialog.styles";
import { FormState, ModuleRatingCommentProps } from "./module-rating-comment-dialog.types";
import { PrimaryButton } from "../../../../../infecto-lms-webapp/components/buttons/PrimaryButton";
import { ValidatedField } from "../../../../../infecto-lms-webapp/components/form/ValidatedField.component";
import { CREATE_MODULE_RATING_MUTATION } from "../module-rating/module-rating.graphql";

export const ModuleRatingCommentDialogComponent = ({
	isVisible,
	setIsVisible,
	rootNodeId,
	value,
	setUpdatingStars,
}: ModuleRatingCommentProps) => {
	const [commitCreate] = useMutation<moduleRating_createModuleRatingSubmissionMutation>(
		CREATE_MODULE_RATING_MUTATION,
	);

	const formik = useFormik<FormState>({
		initialValues: {
			message: "",
		},
		onSubmit: (values) => {
			commitCreate({
				variables: {
					input: {
						nodeRef: rootNodeId,
						value: value,
						message: values.message,
					},
				},
				onCompleted() {
					setIsVisible(false);
					setUpdatingStars(true);
				},
			});
		},
	});

	return (
		<StyledDialog
			header="Vielen Dank für Ihre Bewertung!"
			visible={isVisible}
			onHide={() => setIsVisible(false)}
		>
			<div>
				<p>
					Ihre Meinung zählt! Lassen Sie uns wissen, wie Sie das Modul fanden. Ihr Feedback wird
					vertraulich behandelt und nicht veröffentlicht.
				</p>
				<form onSubmit={formik.handleSubmit} className="p-fluid">
					<ValidatedField<FormState, string>
						className="mb-0"
						name={"message"}
						label={""}
						formikConfig={formik}
						component={({ fieldValue, updateField, fieldName }) => {
							return (
								<InputTextarea
									maxLength={250}
									id={fieldName}
									name={fieldName}
									value={fieldValue}
									rows={10}
									onChange={(e) => updateField(e.target.value)}
								/>
							);
						}}
					/>
					<div className="w-full flex justify-content-end mb-2 p-0">
						<span>max 250 zeichen</span>
					</div>
					<div className="w-full flex justify-content-end">
						<div className="w-6rem">
							<PrimaryButton type="submit" label={"SENDEN"} />
						</div>
					</div>
				</form>
			</div>
		</StyledDialog>
	);
};
